import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Context from 'managers/Context';
import smallBackground from './assets/small-bg.webp';
import largeBackground from './assets/large-bg.webp';
import './styles.scss';

const PREVIEW_VARIANTS = {
    large: {
        backgroundImage: largeBackground,
        width: 506,
        height: 490,
    },
    small: {
        backgroundImage: smallBackground,
        width: 506,
        height: 276,
    },
};

const MobileEmailPreview = memo(
    ({
        title = 'Inbox',
        name,
        message = 'Message subject...',
        previewText = 'Preview text',
        variant = 'small',
    }) => {
        const currentTime = useMemo(() => Context.utilsFormats.getNowMoment('HH:mm'), []);

        const selectedVariant = useMemo(() => {
            return PREVIEW_VARIANTS[variant] || PREVIEW_VARIANTS.small;
        }, [variant]);

        const isLarge = useMemo(() => variant === 'large', [variant]);

        const componentStyle = useMemo(() => {
            const width = selectedVariant.width || 390;
            const height = selectedVariant.height || 268;

            return {
                backgroundImage: `url(${selectedVariant.backgroundImage})`,
                aspectRatio: `${width} / ${height}`,
            };
        }, [selectedVariant]);

        const containerClassName = useMemo(
            () =>
                classNames('mobile-email-preview', {
                    'mobile-email-preview--large': isLarge,
                }),
            [isLarge],
        );

        return (
            <div className={containerClassName} style={componentStyle}>
                <div className="mobile-email-preview__header">{title}</div>

                <div className="mobile-email-preview__notifications-list">
                    <div className="mobile-email-preview__notification">
                        <div className="mobile-email-preview__line mobile-email-preview__line--title">
                            {name}
                        </div>
                        <div className="mobile-email-preview__line mobile-email-preview__line--time">
                            {currentTime}
                        </div>
                        <div className="mobile-email-preview__line mobile-email-preview__line--message">
                            {message}
                        </div>
                        <div className="mobile-email-preview__line mobile-email-preview__line--preview">
                            {previewText}
                        </div>
                    </div>
                    {isLarge && (
                        <>
                            <div className="mobile-email-preview__notification fake">
                                <div className="mobile-email-preview__line mobile-email-preview__line--title">
                                    {name}
                                </div>
                                <div className="mobile-email-preview__line mobile-email-preview__line--time">
                                    {currentTime}
                                </div>
                                <div className="mobile-email-preview__line mobile-email-preview__line--message"></div>
                                <div className="mobile-email-preview__line mobile-email-preview__line--preview"></div>
                            </div>
                            <div className="mobile-email-preview__notification fake">
                                <div className="mobile-email-preview__line mobile-email-preview__line--title">
                                    {name}
                                </div>
                                <div className="mobile-email-preview__line mobile-email-preview__line--time">
                                    {currentTime}
                                </div>
                                <div className="mobile-email-preview__line mobile-email-preview__line--message"></div>
                                <div className="mobile-email-preview__line mobile-email-preview__line--preview"></div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    },
);

MobileEmailPreview.displayName = 'MobileEmailPreview';

MobileEmailPreview.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    message: PropTypes.string,
    previewText: PropTypes.string,
    variant: PropTypes.oneOf(Object.keys(PREVIEW_VARIANTS)),
};

export default MobileEmailPreview;
